
    import { Component, Vue, Prop } from 'vue-property-decorator';
    
    import { stepInfoType } from "@/types/Application";
    import StepBase from "@/components/steps/StepBase.vue";
    
    import ReviewAndConnect from "./ReviewAndConnect.vue";

    import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

    import { namespace } from "vuex-class";   
    import "@/store/modules/application";
    const applicationState = namespace("Application");

    @Component({
        components:{
            StepBase,
            ReviewAndConnect
        }
    })

    export default class StepConnect extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;

        @applicationState.State
        public stPgNo!: stepsAndPagesNumberInfoType;

        
    }
